import React from 'react';
import { Box, Toolbar, Breadcrumbs, Link, Typography } from '@mui/material';
import { Outlet, useLocation, Link as RouterLink } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/MenuBar';
import ContrattoBanner from '../components/ContrattoBanner';
import BreadCrumbsNav from '../components/BreadCrumbsNav';


export default function AppLayout({ children }) {
  const location = useLocation();

  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <Box sx={{ display: 'flex' }}>
      <TopBar />
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <ContrattoBanner />
        <BreadCrumbsNav />
        {/*
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <Link underline="hover" color="inherit" component={RouterLink} to="/">
            Dashboard
          </Link>

          {pathnames.map((value, index) => {
            const to = '/' + pathnames.slice(0, index + 1).join('/');
            const isLast = index === pathnames.length - 1;

            return isLast ? (
              <Typography key={to} color="text.primary">
                {value.charAt(0).toUpperCase() + value.slice(1)}
              </Typography>
            ) : (
              <Link
                key={to}
                underline="hover"
                color="inherit"
                component={RouterLink}
                to={to}
              >
                {value.charAt(0).toUpperCase() + value.slice(1)}
              </Link>
            );
          })}
        </Breadcrumbs>*/}

        <Outlet />
      </Box>
    </Box>
  );
}